import { consoleMsg, populateTable } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { updateDeliveryNotes } from "../shared/app-data";
import { validatePage } from "../shared/validation";
import { renderNextButton } from "../shared/templates";

const app = window.app;

export class Details extends HTMLElement {
	async connectedCallback() {
		consoleMsg("Entering page 1...");

		while (!app.content.details) {
			await new Promise((res) => requestAnimationFrame(res));
		}

		this.innerHTML = app.content.details;
		consoleMsg("✅ First page content injected.");

		// Render the next button component
		this.querySelector("#nav-slot").replaceWith(renderNextButton("nextButton1"));

		/*
		Bound here rather than in ionViewDidEnter: that event fires on every entry to page 1,
		so registering there stacks another listener each time the inspector navigates back,
		and validatePage then runs once per accumulated listener. connectedCallback runs once
		per element, so the binding can't accumulate.
		*/
		const nextPage = app.flowManager.getNext(app.routes.details);
		if (nextPage) {
			this.querySelector("#nextButton1").addEventListener("click", () => validatePage(nextPage.route));
		}

		const pageElement = this;

		this.addEventListener("ionViewWillEnter", async () => {
			await initializePage(1, pageElement);
			consoleMsg("PAGE 1 INNER HTML LOADED...");
			consoleMsg("ION VIEW WILL ENTER PAGE 1...");
		});

		this.addEventListener("ionViewDidEnter", async () => {
			consoleMsg("ION VIEW DID ENTER PAGE 1...");

			// Populate all tables with actual data
			for (const [tableId, data] of Object.entries(app.data.dataTables)) {
				populateTable(tableId, data);
			}

			// Inject data into 'Delivery Notes' div
			updateDeliveryNotes();

			await customElements.whenDefined("ion-input");

			/*
			Seed the two editable fields from the NAVS baseline. NAVS passes both inside
			vehicle-info-table (index.php:92), not on navsData. dataTables stays a read-only
			snapshot of what NAVS sent; any value the inspector already entered is restored
			below and overrides this.
			*/
			const vehicleInfo = app.data?.dataTables?.["vehicle-info-table"] ?? {};
			const navsBaselines = {
				"starting-mileage": vehicleInfo["Starting Mileage"],
				"license-plate-number": vehicleInfo["License Plate Number"],
			};

			for (const [id, baseline] of Object.entries(navsBaselines)) {
				if (!baseline) continue;
				const input = pageElement.querySelector(`ion-input#${id}`);
				if (input) input.value = baseline;
			}

			// Retrieve stored page data if available
			const storageKey = app.state.storageKey;
			consoleMsg(`Storage key: ${storageKey}`);
			const saved = await store.get(`${storageKey}_page1`);
			consoleMsg("Saved data:", saved);
			if (saved && saved.page1) {
				const entries = Object.values(saved.page1);

				pageElement.querySelectorAll("ion-input").forEach((ionInput) => {
					const name = ionInput.getAttribute("name");
					if (!name) return;

					// Match on the stored id, never on position — see buildSubmissionData
					const match = entries.find((e) => e.id === name);
					if (match) {
						ionInput.value = match.value;
					}
				});
			}
			const ionRouter = document.querySelector("ion-router");
			consoleMsg(`Ion router: ${ionRouter}`);
			consoleMsg("Routes:", ionRouter?.routes);
		});

		// Wrapping dispatch events in requestAnimationFrame block to address timing issues
		requestAnimationFrame(() => {
			this.dispatchEvent(new CustomEvent("ionViewWillEnter"));
			requestAnimationFrame(() => {
				this.dispatchEvent(new CustomEvent("ionViewDidEnter"));
			});
		});
	}

	disconnectedCallback() {
		consoleMsg("Custom element pageOne disconnected");
	}
}
